import styled, { keyframes } from 'styled-components';

const pulsateRing = keyframes`
	0% {
    transform: scale(.33);
  }
	80%, 100% {
    opacity: 0;
  }
`;

const pulsateDot = keyframes`
  0% {
    transform: scale(.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(.8);
  }
`;

const Dot = styled.span`
	position: relative;
	height: 12px;
	width: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: ${({ margin }) => margin && margin};
	&:before {
		width: 100%;
		height: 100%;
		content: '';
		background-color: #ff2d57;
		border-radius: 50%;
		animation: ${pulsateDot} 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
	}
	&:after {
		content: '';
		display: block;
		position: absolute;
		height: 200%;
		width: 200%;
		background-color: #ff0033;
		border-radius: 50%;
		margin: auto 4px;
		z-index: -1;
		animation: ${pulsateRing} 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
	}
`;
export default Dot;
